var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-label"},[_c('p',{staticClass:"content-label"},[_vm._t("default",function(){return [_vm._v("未命名标题")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }